// extracted by mini-css-extract-plugin
module.exports = {"ColumnContainer":"SortingVisualizer_ColumnContainer__16BCK","Columns":"SortingVisualizer_Columns__38Ny3"};